export default {
  $getway: 'OurwayErp',
  getDataDictId: 'DataDictController/getDataDictId' // 读取特定编号数据字典
};
